// import { dashboard, admindashboard } from './dashboard';
// // ==============================|| MENU ITEMS ||============================== //

// const menuItems = {
//   items: [dashboard],
//   navAdminItems: [admindashboard]
// };

// export default menuItems;

import { dashboard, hoteladmindashboard, admindashboard, categoryStyles } from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItem = {
  items: [dashboard],
  navAdminItems: [admindashboard],
  navHotelAdminItems: [hoteladmindashboard]
};

export default menuItem;
export { categoryStyles, dashboard, hoteladmindashboard, admindashboard };
